module.exports = __webpack_public_path__ + "img/livraria-color.4b52a1e1.svg";